
import {
  sendVerificationCode,
  checkVerificationCode,
  getSupplierInformation,
  sendRemindEmail,
  sendConsultEmail,
  aliYunVerification,
} from '@/services/vendorImportApi';
import { message } from 'antd';

const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
const apiWrap = (apiFunc, ...args) => {
  return async function Wrapper() {
    const res = await apiFunc(...args);
    if (!res.success) {
      res.msg && message.error(res.msg);
      throw new Error(res.msg);
    }
    return res.data;
  };
};

function createForm(obj) {
  return Object
    .keys(obj)
    .reduce((form, prop) => {
      form[prop] = {
        value: obj[prop]
      };
      return form;
    }, {});
}

export default {
  namespace: 'vendorImport',
  state: {
    baseForm: createForm({
      value: '',
      code: '',
    }),
    formType: 'email', // email | phone
    status: 'list', // list/success/error
    vcodeRemain: 0,
    list: []
  },
  effects: {
    *callVcode({ payload }, { call, select }) {
      const data = yield select(state => ({
        type: state.vendorImport.formType,
        value: state.vendorImport.baseForm.value.value,
        verificationData: payload
      }));
      yield call(apiWrap(sendVerificationCode, data));
    },
    *getVcode({ payload }, { put }) {
      yield put.resolve({
        type: 'callVcode',
        payload
      });
      let time = 60;
      while (time >= 0) {
        yield put({
          type: 'updateVcodeTime',
          payload: time
        });
        time--;
        yield delay(1000);
      }
    },
    *submitForm({ payload: { history } }, { call, select }) {
      const innerState = yield select(state => state.vendorImport);
      yield call(apiWrap(checkVerificationCode, {
        type: innerState.formType,
        value: innerState.baseForm.value.value,
        code: innerState.baseForm.code.value
      }));
      history.push('/vendor-import/result');
    },
    *getSupplierInformation({ payload: { history } }, { call, put }) {
      let supplierList;
      try {
        supplierList = yield call(apiWrap(getSupplierInformation));
      } catch (err) {
        history.push('/vendor-import/index');
        return;
      }
      // "scCertificationStatus": 3,    // 注册1 潜在2 合格3
      if (supplierList.length === 0) {
        yield put({
          type: 'updateStatus',
          payload: 'error'
        });
        return;
      }
      // 名下供应商均为合格，则显示success
      const suppliers = supplierList.filter(s => s.vendorInfoDto.scCertificationStatus !== 3);
      if (!suppliers.length) {
        yield put({
          type: 'updateStatus',
          payload: 'success'
        });
        return;
      }
      yield put({
        type: 'updateSuppliers',
        payload: suppliers
      });
    },
    *sendConsultEmail({ payload }, { call }) {
      try {
        yield call(apiWrap(sendConsultEmail, payload));
        message.info('提交成功');
      } catch (error) {
        return Promise.reject(error);
      }
    },
    *sendRemindEmail({ payload }, { call, put }) {
      try {
        yield call(apiWrap(sendRemindEmail, payload));
        yield put({
          type: 'markVendorRemind',
          payload: payload.vendorId
        });
        message.info('提交成功');
      } catch (error) {
        // ignore
      }
    },
    *aliYunVerification({ payload: { data } }, { call }) {
      const res = yield call(aliYunVerification, data);
      return res;
    }
  },
  reducers: {
    updateFormType(state, { payload }) {
      return {
        ...state,
        formType: payload
      };
    },
    updateFormProps(state, { props }) {
      return {
        ...state,
        baseForm: Object.values(props).reduce((obj, prop) => {
          obj[prop.name] = prop;
          return obj;
        }, { ...state.baseForm })
      };
    },
    updateVcodeTime(state, { payload }) {
      return {
        ...state,
        vcodeRemain: payload
      };
    },
    updateStatus(state, { payload }) {
      return {
        ...state,
        status: payload
      };
    },
    updateSuppliers(state, { payload }) {
      return {
        ...state,
        status: 'list',
        list: payload.map(item => ({ ...item, vendorInfoDto: createForm(item.vendorInfoDto) }))
      };
    },
    markVendorRemind(state, { payload }) {
      const index = state.list.findIndex(item => item.vendorInfoDto.vendorId.value === payload);
      return {
        ...state,
        list: state.list.map((item, i) => {
          if (index === i) {
            return {
              ...item,
              remind: true
            };
          }
          return item;
        })
      };
    }
  }
};
